module.exports = __webpack_public_path__ + "img/44.c5a98f5f.jpg";